<template>
  <a
    :href="conditionsDetail.url"
    class="p-i-conditions-panel"
    :class="{ 'has-kind': kindResult }"
  >
    <div class="p-i-conditions-panel__icon">
      <IconInvestedRounded
        :type="iconType"
        :icon-size="36"
        :bg-color="colorCode"
        icon-color="#ffffff"
      />
    </div>
    <div class="p-i-conditions-panel__name">
      <div v-if="kindResult" class="p-i-conditions-panel__name__kind-wrapper">
        <span class="p-i-conditions-panel__name__kind">{{ kindResult }}</span>
      </div>
      <span class="p-i-conditions-panel__name__text" data-translate-skip>{{
        name
      }}</span>
    </div>
    <div class="p-i-conditions-panel__id">
      <SmallText>ID:&nbsp;{{ id }}</SmallText>
    </div>
    <div class="p-i-conditions-panel__point">
      <SmallText :font-size="14" color="#616161" data-translate-skip
        >+&nbsp;{{ addComma(points) }}{{ point }}</SmallText
      >
    </div>
  </a>
</template>

<script lang="ts">
import SmallText from "@/common/components/atoms/SmallText.vue";
import IconInvestedRounded from "@/common/components/icons/IconInvestedRounded.vue";
import commons from "@/common/store/modules/commons";
import { Options, Vue } from "vue-class-component";

import { getThanksOrGrantTypeLabel } from "@/common/assets/js/utils/types";
import { mapState } from "vuex";

@Options({
  props: {
    conditionsDetail: { type: Object, default: () => ({}) }
  },
  components: {
    SmallText,
    IconInvestedRounded
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class IConditionsListPanel extends Vue {
  conditionsDetail: any | unknown;
  unit = commons.unit;
  point = commons.OrgPageSpecific?.point_name;
  storeColorCode: string;

  get id() {
    return this.conditionsDetail.id;
  }

  get name() {
    return this.conditionsDetail.name;
  }
  get kindResult() {
    return getThanksOrGrantTypeLabel(this.conditionsDetail.kind);
  }

  get iconType() {
    return this.conditionsDetail.grant_criteria_icon_id;
  }

  get points() {
    return this.conditionsDetail.points;
  }

  get url() {
    return this.conditionsDetail.url;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return this.storeColorCode;
  }
  
  addComma(value: any) {
    const number = Number(value);
    if (Number.isNaN(number)) {
      return value;
    }
    return number.toLocaleString();
  }
}
</script>

<style lang="scss" scoped>
.p-i-conditions-panel {
  @include pc {
    display: flex;
    align-items: center;
  }
  @include sp {
    display: grid;
    &.has-kind {
      grid-template:
        "icon kind id" rem(22)
        "icon name id" rem(22)
        "icon point id" rem(22) #{"/"}
        rem(36) 1fr rem(70);
    }
    &:not(.has-kind) {
      grid-template:
        "icon name id" rem(22)
        "icon point id" rem(22) #{"/"}
        rem(36) 1fr rem(70);
    }
  }
  width: 100%;
  padding: rem(8) rem(16);

  &__icon {
    @include pc() {
      display: flex;
      align-items: center;
    }
    @include sp() {
      grid-area: icon;
      align-self: center;
    }
    margin-right: rem(20);
  }

  &__name {
    @include pc {
      flex-grow: 1;
    }
    @include sp {
      display: contents;
    }

    &__kind-wrapper {
      @include pc {
        margin-bottom: rem(4);
      }
      @include sp {
        grid-area: kind;
        padding: 0 rem(8);
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    &__kind {
      align-self: center;
      font-size: rem(10);
      font-weight: bold;
      color: white;
      background-color: black;
      border-radius: 0.5rem;
      padding: rem(2) rem(8);
      display: inline-block;
      @include pc {
        word-break: break-all;
      }
      @include sp {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        max-width: 100%;
      }
    }

    &__text {
      font-size: rem(14);
      font-weight: bold;
      @include pc {
        word-break: break-all;
      }
      @include sp {
        padding: 0 rem(8);
        grid-area: name;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  &__id {
    @include pc {
      min-width: rem(150);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    @include sp {
      grid-area: id;
    }
    padding: 0 rem(8);
    text-align: center;
  }

  &__point {
    @include pc {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    @include sp {
      grid-area: point;
    }
    min-width: rem(150);
    padding: 0 rem(8);
  }
}
</style>
